/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const SearchIcon = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5241 10.3922C14.671 7.76273 14.3686 3.95093 11.8076 1.67506C9.20922 -0.634117 5.20486 -0.545327 2.71714 1.87663C0.229416 4.29858 0.138215 8.19708 2.5101 10.7268C4.84777 13.22 8.76308 13.5145 11.4639 11.4244L16.1748 16.008L16.1842 16.0164C16.4815 16.2643 16.9248 16.2477 17.2016 15.9781C17.4785 15.7087 17.4955 15.2771 17.2409 14.9876L17.2323 14.9785L12.5241 10.3922ZM11.4753 11.2066C11.4754 11.2066 11.4753 11.2066 11.4753 11.2066ZM2.29067 6.40908C2.29067 9.14173 4.56609 11.357 7.37295 11.357C10.1798 11.357 12.4552 9.14173 12.4552 6.40908C12.4552 3.67643 10.1798 1.46118 7.37295 1.46118C4.56609 1.46118 2.29067 3.67643 2.29067 6.40908Z"
        fill="#7E92A2"
      />
    </svg>
  )
}
